import { takeLatest, put, take } from 'redux-saga/effects';
import * as appointmentListReq from '../requests/appointment-list-req';
import * as changeStatusReq from '../requests/change-status-req';
import { UI_POPUP_TYPES } from '../../../constants/props';
import * as popup from '../../ui/popup';

export function* changeStatus({ payload }) {
  const { id, status } = payload;
  const { id: statusId, statusChangeInfoRequired } = status;

  if (statusChangeInfoRequired) {
    yield put({
      type: popup.consts.SHOW,
      payload: {
        contentType: UI_POPUP_TYPES.DASHBOARD_CHANGE_STATUS,
        contentOptions: { id, status },
      },
    });

    yield take(changeStatusReq.consts.SUCCEED);
    yield put(appointmentListReq.actions.removeItem({ id }));
    yield put({
      type: popup.consts.HIDE,
    });
  } else {
    yield put(changeStatusReq.actions.send({ id, statusId }));
  }
}

export default function* addRecordSaga() {
  yield takeLatest(changeStatusReq.consts.UPDATE, changeStatus);
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/change-status-saga.js